var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-1 list-reload-btn",attrs:{"label":_vm.$i18n.t('aava.actions.refresh'),"color":'grey lighten-1',"small":"","icon":"","dark":"","text":""},on:{"click":function($event){return _vm.$emit('reloadListItems')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" fa-sync-alt ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }